<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card class="settings-container">
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-text-field v-model="wpClientId" label="Client ID"
                                :type="showClientInfo ? 'text' : 'password'" outlined></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field v-model="wpClientSecret" label="Client Secret"
                                :type="showClientInfo ? 'text' : 'password'" outlined></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-btn color="primary" @click="showModal = true">Göster</v-btn>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
            <v-flex xs12>
                <v-card class="documentation-link">
                    <p>Dokümantasyonu incelemek için <a href="https://www.vatansms.com/whatsapp-toplu-mesaj-api" target="_blank">buraya</a>
                        tıklayın.</p>
                </v-card>
            </v-flex>
        </v-layout>

        <v-dialog v-model="showModal" max-width="500px">
            <v-card>
                <v-card-title>
                    Parola Gerekiyor
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="password" label="Parola" type="password" outlined></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="showModal = false">İptal</v-btn>
                    <v-btn color="blue darken-1" text @click="checkPassword">Göster</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex';

export default {
    name: 'Documentation',
    components: {},
    data: () => ({
        wpClientId: '****************************************************************',
        wpClientSecret: '****************************************************************',
        showClientInfo: false,
        showModal: false,
        password: '',
    }),
    methods: {
        ...mapActions({ send: 'sendBackend' }),
        checkPassword() {
            this.send({
                route: "show/api/credentials",
                data: {
                    password: this.password,
                },
            }).then((res) => {
                if (res.data.code === 200 && res.data.status === 'success') {
                    this.showClientInfo = true;
                    this.showModal = false;
                    this.wpClientId = res.data.data.wp_client_id;
                    this.wpClientSecret = res.data.data.wp_client_secret;
                }
            }).catch((error) => {
                
            });
        }
    },
};
</script>

<style scoped>
.settings-container {
    padding: 20px;
    margin-bottom: 20px;
}

.documentation-link {
    padding: 20px;
    margin-top: 20px;
}

.v-card {
    border: 1px solid #ccc;
    border-radius: 8px;
}

.v-card-title {
    font-size: 18px;
    font-weight: bold;
}

.v-card-text {
    margin-bottom: 20px;
}

.v-btn {
    margin-top: 20px;
}
</style>